import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/site/Hero";
import ReviewsMarquee from "@/components/site/ReviewsMarquee";
import AboutSection from "@/components/site/AboutSection";
import ServicesGrid from "@/components/site/ServicesGrid";
import WhyChoose from "@/components/site/WhyChoose";
import Gallery from "@/components/site/Gallery";
import VideoShowcase from "@/components/site/VideoShowcase";
import PropertyManagement from "@/components/site/PropertyManagement";
import ContactSection from "@/components/site/ContactSection";
import Seo from "@/components/site/Seo";
import { BRAND } from "@/data/content";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [location]);

  return (
    <div data-testid="home-page">
      <Seo
        title="Landscaping, Lawn Care & Property Services in Tampa Bay, FL"
        description="Locally owned Tampa Bay company delivering reliable, high-quality property service — landscaping, monthly lawn maintenance, landscape lighting, drainage, retaining walls, pavers, and handyman work. 5.0 on Google. Call 727-266-9625 for a free estimate."
        path="/"
        image={BRAND.logo}
      />
      <Hero />
      <ReviewsMarquee />
      <AboutSection />
      <VideoShowcase />
      <PropertyManagement />
      <ServicesGrid />
      <WhyChoose />
      <Gallery />
      <ContactSection />
    </div>
  );
}
